import { useQuery } from "@tanstack/react-query";
import { getCompanyRole } from "@/lib/api/handlers/CompanyRoleHandling";
import type { CompanyRole } from "@/types/CompanyRole";

function isServerErr(x: unknown): x is { isServerError: true } {
  return !!x && typeof x === "object" && "isServerError" in x && (x as { isServerError?: boolean }).isServerError === true;
}

// Resolve the caller's actual company role for builder pages that live
// outside an EventProvider (template editors). Fails closed to "VIEWER"
// while loading or on error so write affordances stay hidden until the
// real role is known. Backend remains the authoritative gate.
export function useCompanyRoleString(): string {
  const q = useQuery({
    queryKey: ["builder", "companyRole"],
    queryFn: () => getCompanyRole("role"),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });
  if (!q.data || isServerErr(q.data)) return "VIEWER";
  const role = (q.data as CompanyRole).role;
  return role && role.length > 0 ? role : "VIEWER";
}
